import { formatAICost } from "../../../utils/currency";

// Validation utilities
export const validateDateRange = (startDate, endDate) => {
  const errors = {};
  if (!startDate) errors.startDate = "Start date required";
  if (!endDate) errors.endDate = "End date required";
  if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start > end) errors.dateRange = "Start date must be before end date";
    const daysDiff = Math.floor((end - start) / (1000 * 60 * 60 * 24));
    if (daysDiff > 90) errors.dateRange = "Range cannot exceed 90 days";
  }
  return { isValid: Object.keys(errors).length === 0, errors };
};

// Costs come from the API in USD; INR uses the rate the API reports.
export const formatCurrency = (amount, currency = "USD", usdToInrRate = 90) => {
  const value = Number(amount) || 0;
  return formatAICost(currency === "INR" ? value * usdToInrRate : value, currency);
};

export const formatNumber = (num) => {
  try {
    return typeof num === "number" && !isNaN(num) ? num.toLocaleString() : "0";
  } catch {
    return "0";
  }
};

export const formatTokens = (tokens) => {
  try {
    return typeof tokens === "number" && !isNaN(tokens) && tokens > 0
      ? `${(tokens / 1_000_000).toFixed(2)}M`
      : "0M";
  } catch {
    return "0";
  }
};

export const formatDuration = (seconds) => {
  try {
    if (!seconds || isNaN(seconds)) return "0s";

    const totalSeconds = Math.floor(seconds);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    const parts = [];

    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (secs > 0 || parts.length === 0) parts.push(`${secs}s`);

    return parts.join(" ");
  } catch {
    return "0s";
  }
};
